export default __webpack_public_path__ + "static/ButtonCover-27a8c30ccc22d04d98805367bf7c0fe1.png";